<template>
  <v-container class="py-8">
    <v-row>
      <v-col cols="12" class="pb-0">
        <p class="body-1 font-weight-bold text--secondary mb-0">
          Total data bulan {{ months[curentMonth].label }}
        </p>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col
            v-for="(summaryData, i) in loading.summary ? 4 : summary"
            :key="`loading-summary-${i}`"
            cols="12"
            sm="6"
            md="3"
          >
            <v-skeleton-loader
              width="100%"
              height="112"
              :loading="loading.summary"
              transition="scale-transition"
              type="card"
            >
              <v-card outlined>
                <v-card-text>
                  <v-row align="center" justify="space-between">
                    <v-col cols="8">
                      <p class="body-2 mb-2 font-weight-bold">
                        {{ summaryData.status }}
                      </p>
                      <p class="text-h6 text-lg-h4 mb-0 font-weight-bold">
                        {{ summaryData.value }}
                        <span class="caption">
                          {{ summaryData.caption }}
                        </span>
                      </p>
                    </v-col>
                    <v-col cols="4">
                      <v-card color="light-green" class="text-center" dark>
                        <v-card-text class="pa-2 pa-lg-4">
                          <v-icon color="white">
                            {{ summaryData.icon }}
                          </v-icon>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col cols="12" md="7">
        <v-row>
          <v-col cols="12">
            <div class="body-1 font-weight-bold text--secondary">
              Grafik trending keyword
            </div>
            <v-divider class="mb-4" />
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  outlined
                  dense
                  color="light-green"
                  label="Tahun"
                  hide-details
                  :items="years"
                  item-text="label"
                  item-value="value"
                  v-model="filters.year"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  outlined
                  dense
                  color="light-green"
                  label="Bulan"
                  hide-details
                  :items="months"
                  item-text="label"
                  item-value="value"
                  v-model="filters.month"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="6" v-if="loading.barTrending">
            <div
              class="text-center"
              style="padding-top: 10rem; padding-bottom: 10rem;"
            >
              <p class="title teal--text text--darken-1 mt-5 mb-5">
                Menunggu data . . .
              </p>
              <v-progress-linear
                color="light-green"
                indeterminate
                rounded
                height="6"
              >
              </v-progress-linear>
            </div>
          </v-col>
          <v-col cols="12" v-if="!loading.barTrending">
            <div>
              <apexchart
                height="400"
                :options="barTrending.chartOptions"
                :series="barTrending.series"
              >
              </apexchart>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex flex-column justify-space-between" cols="12" md="5">
        <v-row>
          <v-col>
            <div class="body-1 font-weight-bold text--secondary">
              Persentase trending keyword
            </div>
            <v-divider />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="6" v-if="loading.pieTrending">
            <div
              class="text-center"
              style="padding-top: 10rem; padding-bottom: 10rem;"
            >
              <p class="title teal--text text--darken-1 mt-5 mb-5">
                Menunggu data . . .
              </p>
              <v-progress-linear
                color="light-green"
                indeterminate
                rounded
                height="6"
              >
              </v-progress-linear>
            </div>
          </v-col>
          <v-col
            cols="12"
            v-if="!loading.pieTrending && pieTrending.series.length < 1"
          >
            <div
              class="text-center"
              style="padding-top: 10rem; padding-bottom: 10rem;"
            >
              <p class="title teal--text text--darken-1 mt-5 mb-5">
                <v-icon x-large class="d-block mb-2" color="light-green">
                  mdi-alert-circle-outline
                </v-icon>
                Belum ada data
              </p>
            </div>
          </v-col>
          <v-col
            cols="12"
            v-if="!loading.pieTrending && pieTrending.series.length > 0"
          >
            <div>
              <apexchart
                height="400"
                :options="pieTrending.chartOptions"
                :series="pieTrending.series"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dashboard from '@/mixins/dashboard';
export default {
  mixins: [dashboard]
};
</script>
